@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.checkboxContainer {
  display: inline-block;
  cursor: pointer;
}

.checkbox {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  background-color: v.$palette-white; // not active background
  position: relative;
  transition: background-color 0.3s ease;
  border: 1px solid rgba(201, 207, 219, 1);

  &.checked {
    background-color: rgba(0, 111, 241, 1); // active background
    border: none;
    outline: 2px solid #dceeff;
  }

  .checkmark {
    display: none;
  }

  &.checked .checkmark {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 5px;
    height: 8px;
    border: solid v.$palette-pure-white;
    border-radius: 1px;
    border-width: 0 2px 2px 0;
    transform: translate(-50%, -60%) rotate(45deg);
  }
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
